import { render, staticRenderFns } from "./DarkRoomElement.vue?vue&type=template&id=784c483e&scoped=true&"
import script from "./DarkRoomElement.vue?vue&type=script&lang=js&"
export * from "./DarkRoomElement.vue?vue&type=script&lang=js&"
import style0 from "./DarkRoomElement.vue?vue&type=style&index=0&id=784c483e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c483e",
  null
  
)

export default component.exports